export default __webpack_public_path__ + "static/media/leads.cf9b1a59.svg";